import { z } from "zod";
import { safeParse } from "../../lib/zod";
import { Schema } from "../../common";
import {
  ControlDefinition,
  serialize
} from "../definition";
import { DefaultControlInstance } from "../instance";
class Definition extends ControlDefinition {
  static type = "makeswift::controls::combobox";
  static schema(item) {
    const type = z.literal(Definition.type);
    const data = z.object({
      id: z.string(),
      value: item,
      label: z.string()
    });
    const value = data;
    const resolvedValue = item.optional();
    const options = z.array(data);
    const config = z.object({
      getOptions: z.function().args(z.string()).returns(z.union([options, z.promise(options)])),
      label: z.string().optional()
    });
    const definition = z.object({
      type,
      config
    });
    return {
      type,
      data,
      value,
      resolvedValue,
      config,
      definition
    };
  }
  static deserialize(data) {
    if (data.type !== Definition.type) {
      throw new Error(
        `Combobox: expected type ${Definition.type}, got ${data.type}`
      );
    }
    const { config } = Definition.schema(Schema.data).definition.parse(data);
    return Combobox(config);
  }
  get controlType() {
    return Definition.type;
  }
  get schema() {
    return Definition.schema(Schema.data);
  }
  safeParse(data) {
    return safeParse(this.schema.data, data);
  }
  fromData(data) {
    return data;
  }
  toData(value) {
    return value;
  }
  copyData(data, _context) {
    return data;
  }
  resolveValue(data) {
    return {
      name: Definition.type,
      readStable: () => this.fromData(data)?.value,
      subscribe: () => () => {
      },
      triggerResolve: async () => {
      }
    };
  }
  createInstance(sendMessage) {
    return new DefaultControlInstance(sendMessage);
  }
  serialize() {
    return serialize(this.config, {
      type: Definition.type
    });
  }
}
class ComboboxDefinition extends Definition {
}
function Combobox(config) {
  return new ComboboxDefinition(config);
}
export {
  Combobox,
  ComboboxDefinition
};
//# sourceMappingURL=combobox.js.map